import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TunnelSanteIconComponent } from './components/icon/tunnelsante-icon.component';

@NgModule({
  imports: [CommonModule],
  declarations: [TunnelSanteIconComponent],
  exports: [TunnelSanteIconComponent],
})
export class TunnelSanteIconModule {}
